import { useState, useCallback } from 'react';
import { xor } from 'lodash';
import { FIELD_TYPES } from 'utility/constants';
import FieldService from 'services/FieldService';

export const useRelationshipSubmit = ({
  onHide,
  onSubmit,
  field,
  stagedValue,
  value,
  setStagedValue,
  handleUpdateTableRecords,
  setShow,
  displayValue,
  handleChange,
}) => {
  const [modal, setModal] = useState(false);
  const [conflicts, setConflicts] = useState([]);
  const [isHideClick, setIsHideClick] = useState(true);

  const handleHide = useCallback(
    async (e) => {
      if (!isHideClick) {
        return;
      }
      if (modal) {
        const confirmModal = document.querySelector('.rel-confirm-modal');
        if (confirmModal && confirmModal.contains(e?.target)) {
          return;
        }
      }
      if (!stagedValue) {
        setShow(false);
        onSubmit?.(true);
      }

      setShow(false);
      onHide?.();
      await onSubmit?.();
      if (conflicts.length) {
        handleUpdateTableRecords(conflicts, field);
        setConflicts([]);
      }
      setIsHideClick(true);
    },
    [
      onHide,
      onSubmit,
      modal,
      stagedValue,
      isHideClick,
      setShow,
      conflicts,
      handleUpdateTableRecords,
      field,
    ]
  );

  const handleChangeWithConfirmation = useCallback(
    async (selectedValue, action) => {
      handleChange(selectedValue);

      if (
        field?.fieldType === FIELD_TYPES.Relationship.type &&
        ['one_to_many', 'one_to_one'].includes(field.relation?.cardinality)
      ) {
        if (action?.action === 'select-option') {
          const value = !Array.isArray(selectedValue)
            ? selectedValue
            : action.option;

          const relatedField = field?.relation?.relatedField;

          setIsHideClick(false);

          const entityRecord = await FieldService.getEntityRecordById(
            field?.relation?.relatedObject,
            value.value
          );

          const primaryEntityId = entityRecord?.fields[relatedField]?.value.id;

          if (primaryEntityId) {
            setConflicts((prev) =>
              prev.concat({ entityValue: value, primaryEntityId })
            );
            setModal(true);
          } else {
            setIsHideClick(true);
          }
        } else if (action?.action === 'remove-value') {
          setConflicts((prev) =>
            prev.filter(
              (conflict) => conflict.entityValue?.value !== action.option
            )
          );
        } else if (action?.action === 'clear') {
          setConflicts([]);
        }
      }
    },
    [field, handleChange]
  );

  const handleConfirm = useCallback(() => {
    setIsHideClick(true);
    setTimeout(() => setModal(false));
  }, []);

  const handleHideConfirm = () => {
    setIsHideClick(true);
    setStagedValue(
      field.relation.cardinality === 'one_to_many'
        ? xor(displayValue, [conflicts.at(-1).entityValue])
        : value
    );
    setConflicts([]);
    setTimeout(() => setModal(false));
  };

  return {
    handleHide,
    handleConfirm,
    handleHideConfirm,
    modal,
    handleChangeWithConfirmation,
  };
};
